<template>
  <div>
    <!-- Cabeçalho -->
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="PSE"
            description="Atividades realizadas no Programa Saúde na Escola (2025 a 2026)"
            url="/dashboard"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://esus-feedback.gitbook.io/esus-feedback/pse"
            pageIdentifier="pse"
          />
        </div>
      </div>

      <!-- Tabs -->
      <div class="row">
        <div class="col-md-12">
          <b-tabs
            id="tabs-pse"
            key="tabs-pse"
            fill
            class="esus-feedback-tabs tabs-auto"
            v-model="tabsActive"
          >
            <!-- Tab Prioritárias -->
            <b-tab title="Prioritárias" active>
              <template v-slot:title>
                <i class="icofont-list"></i> Prioritárias
              </template>
              <prioritarias></prioritarias>
            </b-tab>

            <!-- Tab Outras Práticas -->
            <!-- <b-tab title="Outras Práticas">
              <template v-slot:title>
                <i class="icofont-ui-settings"></i> Outras Práticas
              </template>
              <outras-praticas></outras-praticas>
            </b-tab> -->

            <!-- Tab Outros Temas -->
            <!-- <b-tab title="Outros Temas">
              <template v-slot:title>
                <i class="icofont-chart-flow"></i> Outros Temas
              </template>
              <outros-temas></outros-temas>
            </b-tab> -->
          </b-tabs>
        </div>
      </div>
    </div>
    <!-- Rodapé -->
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import * as Functions from './functions.js'
import store from '@/store/store'
import OutrasPraticas from './OutrasPraticas.vue'
import OutrosTemas from './OutrosTemas.vue'
import Prioritarias from './Prioritarias.vue'

export default {
  name: 'PSE',
  metaInfo: {
    title: 'PSE',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    DownloadFiles,
    OutrasPraticas,
    OutrosTemas,
    Prioritarias,
  },
  data() {
    const cidade = store.state.cidade || 'Cidade'
    const now = new Date()
    const day = String(now.getDate()).padStart(2, '0')
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const year = now.getFullYear()
    const formattedDate = `${day}_${month}_${year}`

    return {
      ultimaAtualizacao: this.$store.getters['getUltimaAtualizacao'],
      mainExportName: `PSE_${cidade}_${formattedDate}`,
      tabsActive: 0,
    }
  },
}
</script>

<style>
.table-expand {
  width: 100%;
  table-layout: auto;
}

.table-expand-details {
  background-color: #f9f9f9;
}

.dropdown-files .btn.dropdown-toggle {
  background-color: #545b62 !important;
  border-color: #4e555b !important;
  color: #fff !important;
}

.dropdown-files .btn.dropdown-toggle:focus,
.dropdown-files .btn.dropdown-toggle:active,
.dropdown-files .btn.dropdown-toggle:not(:disabled):not(.disabled):active,
.dropdown-files .btn.dropdown-toggle:not(:disabled):not(.disabled):focus {
  background-color: #545b62 !important;
  border-color: #4e555b !important;
  box-shadow: none !important;
}

.dropdown-files .dropdown-item:hover,
.dropdown-files .dropdown-item:active {
  background-color: #f5f5f5 !important;
  color: #000 !important;
}

.dropdown-files .dropdown-item {
  color: #545b62 !important;
}

.dropdown-files .dropdown-item i {
  margin-right: 6px;
  color: #545b62 !important;
}

.export-col {
  width: 100px;
  text-align: right;
}

.export-col .dropdown-files {
  display: inline-block;
}

.export-col .dropdown-files .btn {
  white-space: nowrap;
}

.download-right {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.no-wrap {
  white-space: nowrap;
}

.col-escola {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.unidade-saude {
  min-width: 200px;
}

.expanded-content {
  max-height: 400px;
  overflow-y: auto;
}

.esus-feedback-tabs {
  margin-bottom: 20px;
}

.esus-feedback-tabs .nav-tabs {
  border-bottom: 2px solid #dee2e6;
}

.esus-feedback-tabs .nav-tabs .nav-link {
  border: none;
  color: #6c757d;
  padding: 10px 20px;
  margin-right: 5px;
}

.esus-feedback-tabs .nav-tabs .nav-link.active {
  color: #0d98bb;
  border-bottom: 2px solid #0d98bb;
  margin-bottom: -2px;
}

.esus-feedback-tabs .nav-tabs .nav-link i {
  margin-right: 5px;
}

.prioritarias,
.outras-praticas,
.outros-temas {
  padding: 20px 0;
}
</style>
